module.exports = __webpack_public_path__ + "img/small_whale25.f254be77.jpg";